import React, {useState, useEffect} from 'react'
import {
    Modal,
    Button,
    ProgressBar
} from 'react-bootstrap'
import axios from 'axios'
import { onlyTextAndNumbers } from '../utils/inputs';

function ModalRenameFolder(props) {

    const [showModal,       setshowModal]  = useState(false);

    const [sending,         setsending]         = useState(false);
    const [successmessage,  setsuccessmessage]  = useState('');
    const [errormessage,    seterrormessage]    = useState('');
    const [progress,        setprogress]        = useState(0);
    const [count,           setcount]           = useState(0);
    const [folder,          setfolder]          = useState(null);

    const [errors,   seterrors]                         = useState({});
    const [name,            setname]            = useState((props.folder) ? props.folder.name : '');

    const validate = () => {
        let errors = {};
        let countErrors = 0;
        if(props.folder && props.folder !== null){
            if(name === props.folder.name){
                seterrormessage('Debe cambiar el nombre para actualizar');
                countErrors++;
            }
        }

        if(countErrors > 0){
            return false;
        }

        return true;
    }

    useEffect(() => {

        if(props.show === true){
            if(!showModal){
                setshowModal(props.show);
                setsuccessmessage('');
                seterrormessage('');
                setprogress(0);
                setcount(0);
                setfolder('');
                setname('');
            }
        }else{
            setshowModal(props.show);
        }

        //console.log(folder);
        //console.log(props.folder);
        
        if(props.folder !== folder && props.folder !== null && props.folder !== undefined){
            console.log('Actualizando carpeta');
            setsending(false);
            
            setsuccessmessage('');
            seterrormessage('');
            setprogress(0);
            setcount(0);
            setfolder(props.folder);
            setname(props.folder.name);
        } 
    });

    const createFolder = (e) => {
        let url = '';
        if(props.folder){
            if(props.isShare){
                if(props.parent){
                    url = '/filemanager/shared-with-me/folders/'+props.parent+'/descendant/'+props.folder.id+'/';
                }else{
                    url = '/filemanager/shared-with-me/folders/'+props.folder.id+'/';
                }
            }else{
                url = '/filemanager/my-drive/folders/'+props.folder.id+'/';
            }
        }

        let isvalid = validate();

            if(isvalid){
                
            seterrors({});
            setsending(true);
            setsuccessmessage('');
            seterrormessage('');  

            axios({
                url: url,
                method: 'put',
                data: {
                    name
                }
            }).then((res) => {
                console.log(res.datadata);
                setsending(false);
                setname('');
                if(props.folder){
                    setsuccessmessage('Subcarpeta renombrada correctamente');
                }else{
                    setsuccessmessage('Carpeta renombrada correctamente');
                }

                //refresh
                if(props.refresh){
                    props.refresh();
                }
                setTimeout(() => {
                    props.close();
                }, 1000);
            }).catch((err) => {
                console.error(err);
                setsending(false);
                if(err.response.data){
                    seterrors(err.response.data);
                }

                if(err.response.data.hasOwnProperty('non_field_errors')){
                    seterrormessage(err.response.data.non_field_errors);
                }else if(err.response.data.hasOwnProperty('name')){
                    seterrormessage(err.response.data.name);
                }
            });
        }
    }

    return (
        <div>
            <Modal show={showModal} onHide={props.close}>
                <Modal.Header closeButton>
                <Modal.Title>
                    <strong>Renombrar {props.folder ? 'subcarpeta' : 'carpeta'}</strong>
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(successmessage !== '') &&
                        <div className="mb-3 alert alert-success">
                            <p className="mb-0 font-weight-bold">{successmessage}</p>
                        </div>
                    }
                    {(errormessage !== '') &&
                        <div className="mb-3 alert alert-danger">
                            <p className="mb-0 font-weight-bold">{errormessage}</p>
                        </div>
                    }
                    { (progress > 0) &&
                        <div className="py-3">
                            <ProgressBar variant="success" animated now={progress} />
                        </div>
                    }

                    <div className="folder-creator">
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label htmlFor="foldername">Nombre de la carpeta</label>
                                    <input 
                                        onKeyPress={(e) => onlyTextAndNumbers(e)}
                                        value={name}
                                        onChange={(e) => setname(e.target.value)}
                                        placeholder="Nombre de la carpeta"
                                        type="text" 
                                        className="form-control"
                                    />
                                </div>
                                {errors.hasOwnProperty('name') && Array.isArray(errors.name) &&
                                    <div className="help-block d-none text-danger font-weight-bold">
                                        <p className="mb-0 py-2">
                                            <i className="fa fa-exclamation-triangle mr-2"></i>
                                            {errors.name[0]}
                                        </p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={sending} onClick={(e) => createFolder(e)} variant="primary" type="button" >
                        {(sending) ? <span><i className="fa fa-spinner fa-spin mr-2"></i>Cargando</span> : <span><i className="fa fa-ckeck mr-2"></i>Renombrar</span>}
                    </Button>
                    <Button variant="light" onClick={props.close}>
                        <i className="fa fa-times mr-2"></i>Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ModalRenameFolder
